// src/sot/primitives/Switch.jsx //
import React from "react";

export default function Switch({
  checked = false,
  onChange,
  disabled = false,
  className = "",
}) {
  function toggle() {
    if (disabled) return;
    onChange?.(!checked);
  }

  function onKeyDown(e) {
    if (disabled) return;
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      toggle();
    }
  }

  return (
    <div
      role="switch"
      aria-checked={checked}
      aria-disabled={disabled || undefined}
      tabIndex={disabled ? -1 : 0}
      onClick={toggle}
      onKeyDown={onKeyDown}
      className={[
        "inline-flex h-8 w-12 items-center rounded-[100px] px-1",
        "transition-colors duration-150 select-none",
        checked
          ? "bg-[rgb(var(--afrimed-tertiary-container,0,189,196))]"
          : "bg-[rgba(24,50,119,0.10)]",
        disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer",
        className,
      ].join(" ")}
    >
      <span
        className={[
          "relative flex h-6 w-6 items-center justify-center rounded-full",
          "bg-white",
          "shadow-[0_2px_6px_rgba(15,23,42,0.20)]",
          "transform transition-transform duration-150",
          checked ? "translate-x-4" : "translate-x-0",
        ].join(" ")}
      >
        {checked ? (
          <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
            <path
              d="M6.367 10.1 12.017 4.45a.7.7 0 0 1 .966 0 .68.68 0 0 1 0 .95L6.834 11.533a.9.9 0 0 1-1.267 0L3.034 8.667a.68.68 0 0 1 0-.95.9.9 0 0 1 1.267 0L6.367 10.1Z"
              fill="#566A8C"
              fillOpacity="0.6"
            />
          </svg>
        ) : (
          <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
            <path
              d="M8 8.933 4.733 12.2a.9.9 0 0 1-1.267 0 .68.68 0 0 1 0-.95L7 8 3.466 4.467a.68.68 0 0 1 0-.95.9.9 0 0 1 1.267 0L8 7l3.267-3.483a.9.9 0 0 1 1.266 0 .68.68 0 0 1 0 .95L9 8l3.533 3.533a.68.68 0 0 1 0 .95.9.9 0 0 1-1.266 0L8 8.933Z"
              fill="#566A8C"
              fillOpacity="0.6"
            />
          </svg>
        )}
      </span>
    </div>
  );
}
